import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const Video = ({ color, width, height, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={width || '22px'}
      height={height || '22px'}
      color={color || 'currentColor'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M13.944,10.882l-3.742-2.857C10.11,7.937,10,7.971,10,8.143v5.714c0,0.106,0.137,0.177,0.202,0.118
        l3.742-2.857C14.033,11.052,14.033,10.958,13.944,10.882z"
        stroke={color || 'currentColor'}
        strokeWidth="1"
      />
      <circle cx="11" cy="11" r="10" stroke={color || 'currentColor'} strokeWidth="1" />
    </StyledSvg>
  );
};
